import StageAddPage from './add'
export default StageAddPage
